import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '../../../../components/Typography/typography';
import styles from './PauseOption.module.css';

const PauseOption = ({ weeks, onPause, isSelected }) => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(true);

    return (
        <div className={`${styles.pauseOption} ${isSelected ? styles.selected : ''}`}>
            <div className={styles.pauseHeader} onClick={() => setIsOpen(!isOpen)}>
                <Typography 
                    title={t('subscription.pause.option.weeks', { count: weeks })}
                    fontSize={18}
                    weight="600"
                    color="#333"
                />
                <svg 
                    className={`${styles.expandIcon} ${isOpen ? styles.expanded : ''}`}
                    width="12" 
                    height="8" 
                    viewBox="0 0 12 8" 
                    fill="none" 
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path 
                        d="M1.41 0.589844L6 5.16984L10.59 0.589844L12 1.99984L6 7.99984L0 1.99984L1.41 0.589844Z" 
                        fill="#666666"
                    />
                </svg>
            </div>
            <div className={`${styles.pauseContent} ${isOpen ? styles.open : ''}`}>
                <Typography 
                    title={t('subscription.pause.option.description', { count: weeks })}
                    fontSize={14}
                    color="#666"
                    weight="400"
                    className={styles.pauseDescription}
                />
                <button 
                    className={`${styles.pauseButton} ${isSelected ? styles.selectedButton : ''}`}
                    onClick={() => onPause(weeks)}
                >
                    {isSelected ? t('subscription.pause.selected') : t('subscription.pause.button')}
                </button>
            </div>
        </div>
    );
};

export default PauseOption; 